import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Team
} from "@velaro/velaro-component-lib";
import useApi from "@/hooks/useApi";
import React, { useState } from "react";
import LoadingSpinner from "@/components/LoadingSpinner";
import useToastAlert from "@/hooks/useToastAlert";
import { Severity } from "@velaro/velaro-component-lib";
import {
  SecondaryBlueButton,
  PrimaryBlueButton
} from "@velaro/velaro-component-lib";
import TeamForm from "./TeamForm";
import { NewTeam, defaultTeamModel } from "./types";
import IconArrowBack2 from "@/icons/IconArrowBack2";

interface Props {
  show: boolean;
  onClose(): void;
  onTeamCreated(team: Team): void;
}

export default function CreateTeamPanel(props: Props) {
  const api = useApi();
  const [team, setTeam] = React.useState<NewTeam>(defaultTeamModel);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");
  const toastAlert = useToastAlert();

  async function handleSubmit() {
    setSending(true);
    const response = await api.messaging.post("Teams", team);
    if (response.ok) {
      const newTeam = await response.json();
      props.onTeamCreated(newTeam);
      toastAlert.displayToast(Severity.Success, "Team successfully created.");
    } else {
      const error = await response.json();
      setError(error);
    }
    setSending(false);
  }

  if (!team) {
    return <LoadingSpinner />;
  }
  return (
    <div>
      <div className="flex justify-between">
        <div className="flex cursor-pointer" onClick={() => props.onClose()}>
          <IconArrowBack2 />
          <div className="ml-2 hover:underline">Back to Dashboard</div>
        </div>
        <div className="p-4 flex flex-col">
          {error != "" && (
            <div className="flex flex-row mb-4 text-red-500">{error}</div>
          )}
          {sending ? (
            <div className="ml-auto flex">
              Saving Changes...
              <LoadingSpinner />
            </div>
          ) : (
            <div className="ml-auto flex flex-row">
              <PrimaryBlueButton
                type="submit"
                label="Save Changes"
                onClick={handleSubmit}
              />
            </div>
          )}
        </div>
      </div>
      <div className="flex justify-center items-center h-full">
        <div className="panel bg-white rounded-md shadow-md mb-4 p-4 w-1/2">
          <div>
            <div className="flex items-center justify-between">
              <div className="font-medium text-md pb-1">Team Information</div>
              <div className="text-slate-500 text-xs"></div>
            </div>
            <div className="text-slate-600 text-sm pb-2">
              Input team details to streamline collaboration, organization, and
              management within the platform
            </div>
            {/* <hr className="mt-2 mb-4 border-slate-200" /> */}
          </div>

          {/* <div className="flex items-center">
            <div className="w-12 h-12 relative z-0 flex-grow-0 flex-shrink-0"></div>
            <div className="pl-4"></div>
          </div> */}

          <div className="px-4">
            <TeamForm
              team={team}
              onChange={(updates) => {
                setTeam((oldState) => ({ ...oldState, ...updates }));
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
